module.exports = "/_next/static/images/aaf94aab3485cb6a18371307f5c116e4-group-man-building@1x.jpg.webp";